import api from './api.service';

export interface Department {
  id: string;
  company_id: string;
  department_code: string;
  department_name: string;
  parent_department_id?: string;
  department_head?: string;
  cost_center_code?: string;
  description?: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  is_deleted?: boolean;
  parentDepartment?: Department;
}

export interface DepartmentSelectionItem {
  id: string;
  department_code: string;
  department_name: string;
}

export interface DepartmentFilters {
  is_active?: boolean;
}

export interface CreateDepartmentPayload {
  department_code: string;
  department_name: string;
  parent_department_id?: string;
  /** User id of Process Owner (maps to departments.department_head) */
  department_head?: string;
  cost_center_code?: string;
  description?: string;
  is_active?: boolean;
}

function unwrap<T>(response: any): T {
  const data = (response as any)?.data ?? response;
  return (data?.data ?? data) as T;
}

class DepartmentService {
  async list(filters?: DepartmentFilters): Promise<Department[]> {
    const params = new URLSearchParams();
    if (filters?.is_active !== undefined) params.append('is_active', String(filters.is_active));
    const response = await api.get<any>(`/finance/departments?${params.toString()}`);
    const raw = unwrap<Department[]>(response);
    return Array.isArray(raw) ? raw : [];
  }

  async getForSelection(): Promise<DepartmentSelectionItem[]> {
    const response = await api.get<any>('/finance/departments/selection');
    const raw = unwrap<DepartmentSelectionItem[]>(response);
    return Array.isArray(raw) ? raw : [];
  }

  async getById(id: string): Promise<Department> {
    const response = await api.get<any>(`/finance/departments/${id}`);
    return unwrap<Department>(response);
  }

  async create(payload: CreateDepartmentPayload): Promise<Department> {
    const response = await api.post<any>('/finance/departments', payload);
    return unwrap<Department>(response);
  }

  async update(id: string, payload: Partial<CreateDepartmentPayload>): Promise<Department> {
    const response = await api.put<any>(`/finance/departments/${id}`, payload);
    return unwrap<Department>(response);
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/finance/departments/${id}`);
  }
}

export const departmentService = new DepartmentService();
export default departmentService;
